import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FaPhone, FaTimes, FaVideo, FaUser } from 'react-icons/fa';
import styles from './IncomingCallModal.module.css';

const IncomingCallModal = ({
  show,
  callerName,
  callerImage,
  onAccept,
  onReject,
  callType = 'video'
}) => {
  const [isRinging, setIsRinging] = useState(true);

  // Play ringing sound
  useEffect(() => {
    let audio;
    if (show && isRinging) {
      // Create a simple beep sound using Web Audio API
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.value = 440; // A4 note
      oscillator.type = 'sine';

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);

      // Create ringing pattern
      const ring = () => {
        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.2);

        setTimeout(() => {
          if (isRinging) {
            const newOscillator = audioContext.createOscillator();
            newOscillator.connect(gainNode);
            newOscillator.frequency.value = 440;
            newOscillator.type = 'sine';
            newOscillator.start(audioContext.currentTime);
            newOscillator.stop(audioContext.currentTime + 0.2);
          }
        }, 1000);
      };

      const intervalId = setInterval(ring, 2000);

      return () => {
        clearInterval(intervalId);
        try {
          audioContext.close();
        } catch (e) {
          console.error('Error closing audio context:', e);
        }
      };
    }
  }, [show, isRinging]);

  const handleAccept = () => {
    setIsRinging(false);
    onAccept();
  };

  const handleReject = () => {
    setIsRinging(false);
    onReject();
  };

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      className={styles.incomingCallModal}
      contentClassName={styles.modalContent}
    >
      <Modal.Body className={styles.modalBody}>
        <div className={styles.callerInfo}>
          {/* Caller Avatar with Pulse Animation */}
          <div className={styles.avatarContainer}>
            <div className={styles.pulseRing}></div>
            <div className={styles.pulseRing} style={{ animationDelay: '0.5s' }}></div>
            <div className={styles.avatar}>
              {callerImage ? (
                <img src={callerImage} alt={callerName} />
              ) : (
                <FaUser className={styles.avatarPlaceholder} />
              )}
            </div>
          </div>

          {/* Caller Name */}
          <h2 className={styles.callerName}>{callerName}</h2>

          {/* Call Type */}
          <p className={styles.callType}>
            {callType === 'video' ? (
              <>
                <FaVideo className={styles.callIcon} />
                Incoming Video Call
              </>
            ) : (
              <>
                <FaPhone className={styles.callIcon} />
                Incoming Call
              </>
            )}
          </p>

          {/* Ringing Animation */}
          <div className={styles.ringingText}>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.actionButtons}>
          <button
            className={`${styles.actionButton} ${styles.rejectButton}`}
            onClick={handleReject}
            title="Reject"
          >
            <FaTimes />
          </button>

          <button
            className={`${styles.actionButton} ${styles.acceptButton}`}
            onClick={handleAccept}
            title="Accept"
          >
            <FaPhone />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IncomingCallModal;
